import { useEffect, useRef, useState } from 'react';

/**
 * Ilustracion de carta que se funde al cargar.
 *
 * POR QUE: es el corte mas visible de toda la interfaz. Las cartas llegan de un
 * proveedor externo, tardan lo que tardan y NO en el orden en que estan puestas,
 * asi que una rejilla apareciendo de golpe y en desorden parece rota aunque
 * este funcionando perfectamente. Fundiendolas, el mismo desorden se lee como
 * contenido que va llegando.
 *
 * El caso de la imagen YA cacheada es el que obliga a mirar el DOM: cuando el
 * navegador la tiene, la pinta antes de que React llegue a enganchar `onLoad`,
 * el evento no se dispara nunca y la carta se queda invisible para siempre. Por
 * eso, al montar, se comprueba `complete` en vez de confiar solo en el evento.
 */
export default function Arte({ className = '', onLoad, ...props }) {
  const [cargada, setCargada] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // Ya estaba en cache: el evento no va a llegar.
    if (ref.current?.complete) setCargada(true);
  }, [props.src]);

  return (
    <img
      /*
       * `decoding="async"` de serie, y por eso vive aqui y no en cada sitio
       * que pinta una carta: la rejilla son SESENTA imagenes y descodificarlas
       * en el hilo principal se nota al desplazar justo mientras van llegando.
       * Va antes del spread para que cualquier llamada pueda pisarlo si algun
       * dia hace falta lo contrario.
       */
      decoding="async"
      {...props}
      ref={ref}
      className={`arte ${className} ${cargada ? 'is-loaded' : ''}`.trim()}
      onLoad={(e) => {
        setCargada(true);
        onLoad?.(e);
      }}
      // Una imagen que falla debe verse igualmente: dejarla en opacidad 0
      // esconderia el hueco y con el la pista de que algo no cargo.
      onError={() => setCargada(true)}
    />
  );
}
